const config = {
  baseUrl: process.env.REACT_APP_baseUrl,
  socketUrl: process.env.REACT_APP_SOCKET_IO_URL,
  imageUrl: process.env.REACT_APP_IMAGE_URL,
  redirectUrl: process.env.REACT_APP_REDIRECT_URL,
};

export default config;
